/**
 * @generated SignedSource<<816242b19149d067cbb39bc233b9c0a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PublicationsPage_page$data = {
  readonly breadcrumbs: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"Breadcrumb_data">;
  } | null | undefined> | null | undefined;
  readonly id: string;
  readonly path: string | null | undefined;
  readonly publicationsList: {
    readonly detailFilter: {
      readonly " $fragmentSpreads": FragmentRefs<"DetailFilter_detailFilter">;
    } | null | undefined;
    readonly documents: ReadonlyArray<{
      readonly archiveName: string | null | undefined;
      readonly deeplinkCode: string | null | undefined;
      readonly docTypeName: string | null | undefined;
      readonly documentTitle: string | null | undefined;
      readonly documentType: string | null | undefined;
      readonly fileDate: string | null | undefined;
      readonly fileName: string | null | undefined;
      readonly fundName: ReadonlyArray<string | null | undefined> | null | undefined;
      readonly id: string | null | undefined;
      readonly isins: ReadonlyArray<string | null | undefined> | null | undefined;
      readonly mimeType: string | null | undefined;
      readonly size: number | null | undefined;
      readonly url: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly filterButtonText: string | null | undefined;
    readonly filterButtonTextExpanded: string | null | undefined;
    readonly liveFilter: {
      readonly " $fragmentSpreads": FragmentRefs<"LiveFilter_liveFilter">;
    } | null | undefined;
    readonly noResultsText: string | null | undefined;
    readonly title: string | null | undefined;
    readonly variousFundsText: string | null | undefined;
    readonly yearLabel: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "PublicationsPage_page";
};
export type PublicationsPage_page$key = {
  readonly " $data"?: PublicationsPage_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"PublicationsPage_page">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PublicationsPage_page",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PublicationsList",
      "kind": "LinkedField",
      "name": "publicationsList",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "yearLabel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "filterButtonText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "filterButtonTextExpanded",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "noResultsText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "variousFundsText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LiveFilter",
          "kind": "LinkedField",
          "name": "liveFilter",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "LiveFilter_liveFilter"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailFilter",
          "kind": "LinkedField",
          "name": "detailFilter",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "DetailFilter_detailFilter"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PublicationDocument",
          "kind": "LinkedField",
          "name": "documents",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "archiveName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mimeType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fileDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "docTypeName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "documentType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "documentTitle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "size",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fileName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deeplinkCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fundName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isins",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Breadcrumb",
      "kind": "LinkedField",
      "name": "breadcrumbs",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Breadcrumb_data"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    (v0/*: any*/)
  ],
  "type": "PublicationsPage",
  "abstractKey": null
};
})();

(node as any).hash = "05b3b5e2a709294c73127f759fb93c50";

export default node;
